
<div class="side-nav-content">
    <ul class="nav-list" [ngClass]="{'nav-list-open': sideNavStatus}">
  
     <li class="nav-list-item " id="dropdown" [ngClass]="{'active': activateLinks.home}">
         <span>
           <a class="submenuLink" href="home"  >
              <svg width="39" height="29" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                 <rect x="3" y="4" width="8" height="10" rx="1" fill="#889099"/>
                 <path d="M3 17C3 16.4477 3.44772 16 4 16H10C10.5523 16 11 16.4477 11 17V19C11 19.5523 10.5523 20 10 20H4C3.44772 20 3 19.5523 3 19V17Z" fill="#A7ADB5"/>
                 <path d="M13 5C13 4.44772 13.4477 4 14 4H20C20.5523 4 21 4.44772 21 5V9C21 9.55228 20.5523 10 20 10H14C13.4477 10 13 9.55228 13 9V5Z" fill="#A7ADB5"/>
                 <rect x="13" y="12" width="8" height="8" rx="1" fill="#D0D4D9"/>
                 </svg>
           Home </a>
           <span class="tooltiptext">Home </span>
        </span>
     </li>
       
        <li class="nav-list-item" id="dropdown" [ngClass]="{'active': activateLinks.releaseNote}">
                    
          <span>
             <a class="submenuLink" href="relnotes">
              <svg width="39" height="29" viewBox="0 0 24 24"  xmlns="http://www.w3.org/2000/svg">
                 <path d="M3 14.5C3 13.6716 3.67157 13 4.5 13C5.32843 13 6 13.6716 6 14.5V19.5C6 20.3284 5.32843 21 4.5 21C3.67157 21 3 20.3284 3 19.5V14.5Z" fill="#D0D4D9"/>
                 <path d="M8 9.5C8 8.67157 8.67157 8 9.5 8C10.3284 8 11 8.67157 11 9.5V19.5C11 20.3284 10.3284 21 9.5 21C8.67157 21 8 20.3284 8 19.5V9.5Z" fill="#889099"/>
                 <path d="M13 12.5C13 11.6716 13.6716 11 14.5 11C15.3284 11 16 11.6716 16 12.5V19.5C16 20.3284 15.3284 21 14.5 21C13.6716 21 13 20.3284 13 19.5V12.5Z" fill="#A7ADB5"/>
                 <path d="M18 7.5C18 6.67157 18.6716 6 19.5 6C20.3284 6 21 6.67157 21 7.5V19.5C21 20.3284 20.3284 21 19.5 21C18.6716 21 18 20.3284 18 19.5V7.5Z" fill="#889099"/>
                 </svg>  
              Release Notes
            </a>
              <span class="tooltiptext">Release Notes</span>
          </span>
       </li>
  
      
  
     <li class="nav-list-item" id="dropdown1"  [ngClass]="{'active': activateLinks.support}">
        <div style="isolation: isolate;" id="submenu1" class="submenu" [style.height.px]="heightmenu" *ngIf="activeMenuNumber==1">    
            <div class="submenu-heading">    
                Support       
            <button class="search__icon icon-close" (click)="closesubmenuclick()" > </button>    
            </div>      
            <div style="border-bottom: 1px solid #e1e4e8; padding: 0;"> </div>
             <ul>
              <li class="subnav-list-item"> <a href="newrequest">New Application Request</a></li>
              <li class="subnav-list-item"><a (click)="opentacsupport()">Request Application Support</a></li>
              <li class="subnav-list-item" ><a (click)="openEncryptedVisibilityEngine()" >Encrypted Visibility Engine Support</a></li>
               <li class="subnav-list-item"><a href="customdetector">Custom Detector</a></li>  
             
           </ul>
        </div> 

         <span (click)="submenuclick(1)"><a class="submenuLink"> <svg width="39" height="29" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
           <path  opacity="0.4" d="M20 14V5.65753C20 5.2575 19.7616 4.89787 19.3939 4.74029L14.3939 2.59743C13.7341 2.31463 13 2.79866 13 3.51658V20.4835C13 21.2014 13.7258 21.665 14.3499 21.3102C16.3841 20.1541 20 17.5936 20 14Z" fill="#889099"/>
           <path d="M4 5.65752V14C4 17.5936 7.61593 20.1541 9.65009 21.3102C10.2742 21.665 11 21.2014 11 20.4835V3.51658C11 2.79866 10.2659 2.31463 9.60608 2.59744L4.60608 4.74029C4.2384 4.89787 4 5.2575 4 5.65752Z" fill="#889099"/>
           </svg>  Support</a> 
           <span class="accordion__toggle icon-chevron-right" style="width: 0px;"></span> 
           <span class="tooltiptext" >Support</span>      
        </span>   
     </li>
  
       
     <li class="nav-list-item" id="dropdown2" [ngClass]="{'active': activateLinks.documentation}">
        <div style="isolation: isolate;" class="tooltip tooltip--top" id="submenu2" class="submenu" [style.height.px]="heightmenu" *ngIf="activeMenuNumber==2">  
            <div class="submenu-heading">    
                Documentation       
            <button class="search__icon icon-close" (click)="closesubmenuclick()" > </button>    
            </div>      
            <div style="border-bottom: 1px solid #e1e4e8; padding: 0;"> </div> 
            <ul class="dropup-content">
           <li class="subnav-list-item"><a (click)="openApplicationDetection()">Application Detection</a></li>
           <li class="subnav-list-item"><a (click)="openOpenId()">OpenAppID</a></li>
           <li class="subnav-list-item"  ><a (click)="openYouTubeVideo()">AppID Portal Intro VoD ( 8 min )</a></li>
           <li class="subnav-list-item"><a (click)="openEncryptedVisibilityDetails()">Encrypted Visibility Engine</a></li>
        </ul>
        </div>
      <span  (click)="submenuclick(2)"><a class="submenuLink">  
         <svg width="39" height="29" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="16" y="16" width="5" height="5" rx="1" fill="#D0D4D9"/>
        <path d="M9.5 10.5C9.5 9.94772 9.94772 9.5 10.5 9.5H13.5C14.0523 9.5 14.5 9.94772 14.5 10.5V13.5C14.5 14.0523 14.0523 14.5 13.5 14.5H10.5C9.94772 14.5 9.5 14.0523 9.5 13.5V10.5Z" fill="#A7ADB5"/>
        <path d="M9.5 17C9.5 16.4477 9.94772 16 10.5 16H13.5C14.0523 16 14.5 16.4477 14.5 17V20C14.5 20.5523 14.0523 21 13.5 21H10.5C9.94772 21 9.5 20.5523 9.5 20V17Z" fill="#A7ADB5"/>
        <path d="M3 4C3 3.44772 3.44772 3 4 3H7C7.55228 3 8 3.44772 8 4V7C8 7.55228 7.55228 8 7 8H4C3.44772 8 3 7.55228 3 7V4Z" fill="#889099"/>
        <path d="M3 10.5C3 9.94772 3.44772 9.5 4 9.5H7C7.55228 9.5 8 9.94772 8 10.5V13.5C8 14.0523 7.55228 14.5 7 14.5H4C3.44772 14.5 3 14.0523 3 13.5V10.5Z" fill="#889099"/>
        <path d="M3 17C3 16.4477 3.44772 16 4 16H7C7.55228 16 8 16.4477 8 17V20C8 20.5523 7.55228 21 7 21H4C3.44772 21 3 20.5523 3 20V17Z" fill="#889099"/>
        </svg> Documentation
    </a> 
    <span class="accordion__toggle icon-chevron-right" style="width: 0px;"></span> 
        <span class="tooltiptext" >Documentation</span>   
    </span>      
     
     </li>
  
     <li class="nav-list-item" id="dropdown3" [ngClass]="{'activeSubmenu': activateLinks.resources}">
        <div style="isolation: isolate;" id="submenu3" class="submenu" [style.height.px]="heightmenu" *ngIf="activeMenuNumber==3">
            <div class="submenu-heading">    
                Resources       
            <button class="search__icon icon-close" (click)="closesubmenuclick()" > </button>    
            </div>      
            <div style="border-bottom: 1px solid #e1e4e8; padding: 0;"> </div>  
            <ul class="dropup-content">
              <li class="subnav-list-item"><a (click)="openVDBSoftwareDownloads()">VDB Software Downloads</a></li>
              <li class="subnav-list-item"><a (click)="openProducts()">Solutions</a></li>
              <li class="subnav-list-item"><a (click)="openPartnerHelp()">Partner Help</a></li>
              <li class="subnav-list-item"><a (click)="openYouTubeChannel()">YouTube Channel</a></li>
              <li class="subnav-list-item"><a (click)="openTalos()">Talos</a></li>
              <li class="subnav-list-item"><a (click)="openDevNetPortal()">DevNet Portal</a></li>
              <li class="subnav-list-item"><a (click)="openTerraformRegistry()">Terraform Registry</a></li>
              <li class="subnav-list-item"><a (click)="openLevelUp()">Level Up</a></li>
           </ul></div>     
            <span (click)="submenuclick(3)"><a class="submenuLink">  <svg width="39" height="29" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 4C2.44772 4 2 4.44772 2 5V15C2 15.5523 2.44772 16 3 16H14.5V9C14.5 8.17157 15.1716 7.5 16 7.5H19V5C19 4.44772 18.5523 4 18 4H3Z" fill="#D0D4D9"/>
              <path d="M13 17H9V19H7.5C7.22386 19 7 19.2239 7 19.5C7 19.7761 7.22386 20 7.5 20H14C14.2761 20 14.5 19.7761 14.5 19.5C14.5 19.2239 14.2761 19 14 19H13V17Z" fill="#D0D4D9"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M17 9C16.4477 9 16 9.44771 16 10V19C16 19.5523 16.4477 20 17 20H21C21.5523 20 22 19.5523 22 19V10C22 9.44772 21.5523 9 21 9H17ZM19 18.5C19.4142 18.5 19.75 18.1642 19.75 17.75C19.75 17.3358 19.4142 17 19 17C18.5858 17 18.25 17.3358 18.25 17.75C18.25 18.1642 18.5858 18.5 19 18.5Z" fill="#889099"/>
              </svg>  Resources
            </a>
            <span class="accordion__toggle icon-chevron-right" style="width: 0px;"></span> 
              <span class="tooltiptext" >Resources</span>  
            </span> 

                 
            
     </li>
  
     <hr>
     <li class="nav-list-item" id="dropdown" [ngClass]="{'active': activateLinks.feedback}">         
        <span>
           <a class="submenuLink" (click)="openModal('desktopModal')">
              <svg width="39" height="29" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                 <path d="M20.7406 6.50937C20.5278 6.27224 20.2677 6.0822 19.9771 5.95143C19.6865 5.82066 19.3718 5.75205 19.0531 5.75H14V4.25C13.9975 3.2562 13.6016 2.30381 12.8989 1.60108C12.1962 0.898358 11.2438 0.502475 10.25 0.5C10.1107 0.50113 9.97426 0.540107 9.85537 0.612764C9.73648 0.685421 9.63957 0.789026 9.575 0.9125L6.03125 8H2C1.60218 8 1.22064 8.15804 0.93934 8.43934C0.658035 8.72064 0.5 9.10218 0.5 9.5V17.75C0.5 18.1478 0.658035 18.5294 0.93934 18.8107C1.22064 19.092 1.60218 19.25 2 19.25H17.9281C18.4754 19.2477 19.0033 19.0469 19.4136 18.6848C19.824 18.3227 20.089 17.824 20.1594 17.2812L21.2844 8.28125C21.3218 7.96434 21.2928 7.6431 21.1992 7.33803C21.1055 7.03296 20.9494 6.75074 20.7406 6.50937ZM2 9.5H5.75V17.75H2V9.5Z" fill="#889099"/>
                 </svg>  Feedback                 
                </a>
                 <span class="tooltiptext">Feedback

                 </span>    
        </span>
  
     </li>
  
     
    </ul>
    
  
  
  </div>  
  
  
  <div id="desktopModal" class="modal rating modal-alligment">
     <div class="modal__dialog">
         <div class="modal__content">
             <div class="modal__header">
                 <div class="modal__title">Feedback</div>
                 <a class="modal__close" (click)="closeModal('desktopModal')"><span class="icon-close"></span></a>
             </div>
             <div class="modal__body container-fluid">
                 <p class="scale_text">On a scale of 0 to 10, how likely are you likely to recommend this tool to a
                     friend or a colleague?
                 </p>
  
                 <div class="row paddings" >
                     <div  *ngFor="let count of buttonArr">
                         <!-- <button ngDefaultControl  [(ngModel)]="scaleCount" [ngStyle]="{'background-color':getColor(count)}" class="pagination__item pagination__link--type-bordered" mat-raised-button (click)="selectScore(count)">{{count}}</button> -->
                         <button ngDefaultControl
                             [ngClass]="[scaleCount==count+'' ? 'btn--state-selected' :'' ,showScale ? 'showWarningRed'  : '']"
                             [(ngModel)]="scaleCount"
                             class="pagination__item pagination__link--type-bordered mat-raised-button_header"
                             (click)="selectScore(count)">{{count}}</button>
  
                     </div>
                 </div>
                 <div class="row">
                     <div class="col-md-3">  <div class="paddings_notlikely">Not likely</div></div>
                     <div class="col-md-3">  <div class="paddings_neutral">Neutral</div> </div>
                     <div class="col-md-2"></div>
                     <div class="col-md-4">  <div class="paddings_extremelylikely">Extremly likely</div> </div>
                 </div>
  
                 <div class="row"><label class="scale_text paddings_label">What can we do better?</label></div>
                 <textarea ngDefaultControl [(ngModel)]="feedBackDescription" class="feedbackdescription"
                     [ngClass]="showDescription ? 'showWarningRed'  : ''"> </textarea>
  
  
                 <div class="row"><label class="useremailcolor paddings_label">Email</label></div>
                 <input type="text" class="useremail" [(ngModel)]="email"
                     [ngClass]="showEmail ? 'showWarningRed'  : ''" />
                 <p>
                     <label class="checkbox">
                         <input type="checkbox" class="checkbox__input" checked ngDefaultControl
                             [(ngModel)]="contactPersmission">
                         <div class="checkbox__box"></div>
                         <div class="checkbox__label scale_text">May we contact you regarding your feedback?</div>
                     </label>
                     <!-- <label class="checkbox">
                         <input type="checkbox" class="checkbox__input">
                         <div class="checkbox__box"></div>
                         <div class="checkbox__label scale_text">Do not show me this again</div>
                     </label> -->
                 </p>
                 <!--
                 <div [ngClass]="showScale ? 'showWarningsBlock'  : 'showWarningsNone'">Please select a scale from 0 to
                     10.</div>
                 <div [ngClass]="showDescription ? 'showWarningsBlock'  : 'showWarningsNone'">Please share your
                     description.</div>
                 <div [ngClass]="showEmail ? 'showWarningsBlock'  : 'showWarningsNone'">Please enter valid email, so we
                     can contact you.</div>
                  -->   
             </div>
             <div class="modal__footer">
                 <!-- <div class="row"> -->
                 <div class="col-md-6" style="text-align: left; ">
                     <a href="http://www.cisco.com/web/siteassets/legal/privacy.html" target="_blank"><span
                             class="privacypolicy" style="color:#0083B3 ; font-size: 14px;font-weight: 700; padding-right: 7px;">Privacy Policy</span>
                         <svg width="15" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" style="color:  #7E868F; height : 18.75px">
                             <path fill-rule="evenodd" clip-rule="evenodd"
                                 d="M8.94833 8.9475H1.0525V1.05167H5.52667V0H0.526667C0.236667 0 0 0.235833 0 0.526667V9.47333C0 9.76333 0.236667 10 0.526667 10H9.47333C9.76417 10 10 9.76333 10 9.47333V4.47333H8.94833V8.9475ZM9.13254 3.14794C9.25679 3.27219 9.38185 3.23214 9.41127 3.05966L9.9998 0L6.93375 0.582013C6.76128 0.611441 6.72123 0.737326 6.84466 0.861576L7.62608 1.64304L5.98394 3.28527C5.78286 3.48636 5.78286 3.81415 5.98394 4.01524C6.18584 4.21714 6.51198 4.21714 6.71387 4.01524L8.35683 2.37219L9.13254 3.14794Z"
                                 fill="#58585B" />
                         </svg>
                     </a>
                 </div>
  
                 <div class="col-md-6" style="text-align: right;">
                     <button class="btn btn--secondary" (click)="closeModal('desktopModal')">Close</button>
                     <button class="btn btn--primary" (click)="submitFeedback()">Submit</button>
                 </div>
  
                 <!-- </div> -->
  
  
             </div>
         </div>
     </div>
  </div>
  
  
  <!--<div class="sidebar" id="mySidebar" [style.width]="sidebarWidth">
  
      
     
      <a href=""class="closebtn" (click)="closeNav()">&times;</a>
      <a class="active" href="#home">Home</a>
  <a href="#news">News</a>
  <a href="#contact">Contact</a>
  <a href="#about">About</a>
    </div> -->